export const VERSION = '2.0.4';
export const GIT_SHA = 'd85f9821';
